module.exports = __webpack_public_path__ + "static/img/clothing_10.930c2d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/clothing_10.png
// module id = xrSV
// module chunks = 0